import { createSlice } from '@reduxjs/toolkit';

import {
    type SetGroupsListAction,
    type SetInviteCodeAction,
    type SetMembersListAction,
    type SocialGroupsState,
} from '@app/store/slices/social-groups/types';

const name = 'socialGroups';

const initialState: SocialGroupsState = {
    inviteCode: null,
    groups: [],
    groupsPaging: { page: 0, limit: 20, total: 0 },
    groupMembers: [],
    groupMembersPaging: { page: 0, limit: 20, total: 0 },
};

export const socialGroupsSlice = createSlice({
    name,
    initialState,
    reducers: {
        setGroupsList(state, { payload }: SetGroupsListAction) {
            state.groups = payload.data;
            state.groupsPaging = payload.paging;
        },
        setMembersList(state, { payload }: SetMembersListAction) {
            state.groupMembers = payload.data;
            state.groupMembersPaging = payload.paging;
        },
        setInviteCode(state, { payload }: SetInviteCodeAction) {
            state.inviteCode = payload;
        },
    },
});
